"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.loadAllInvoices = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _invoiceApi = require("../api/invoiceApi");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Actions
var LOAD_ALL_INVOICES = 'api/reducer/ALL_INVOICES';
var CURRENT_REQUEST = 'api/reducer/CURRENT_REQUEST';

// Reducer
function reducer() {
  var _action$data$source;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case LOAD_ALL_INVOICES:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.data.innerData
      });
    case CURRENT_REQUEST:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentRequest: {
          cancel: (_action$data$source = action.data.source) === null || _action$data$source === void 0 ? void 0 : _action$data$source.cancel,
          token: {
            reason: 'New request was sent'
          }
        }
      });
    default:
      return state;
  }
}

// Action Creators
var loadAllInvoices = exports.loadAllInvoices = function loadAllInvoices(dispatch, contractId) {
  var resp = (0, _invoiceApi.getInvoices)(contractId);
  dispatch({
    type: CURRENT_REQUEST,
    data: {
      source: resp === null || resp === void 0 ? void 0 : resp.source
    }
  });
  return resp.then(function (response) {
    dispatch({
      type: LOAD_ALL_INVOICES,
      data: {
        innerData: response.data
      }
    });
  }).catch(function (error) {
    if (error.type !== 'cancel') {
      dispatch({
        type: LOAD_ALL_INVOICES,
        data: {
          innerData: null
        }
      });
    } else {
      throw error;
    }
  });
};